import { request } from './client';
import { UserSettings } from '../types/settings';

export interface PresetItem {
  id: string;
  name: string;
  description: string;
  settings: Partial<UserSettings>;
}

export interface PresetsResponse {
  items: PresetItem[];
  note?: string;
}

export async function fetchSettings(): Promise<UserSettings> {
  return request<UserSettings>('/settings');
}

export async function fetchSettingsPresets(): Promise<PresetsResponse> {
  return request<PresetsResponse>('/settings/presets');
}

export async function fetchSettingsDefaults(): Promise<any> {
  return request<any>('/settings/defaults');
}

export async function updateSettings(payload: Partial<UserSettings>): Promise<UserSettings> {
  return request<UserSettings>('/settings', {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function getExportBackupUrl(): string {
  return '/api/v1/export';
}

export async function downloadBackup(): Promise<void> {
  const response = await fetch('/api/v1/export', {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`备份导出失败 (${response.status})`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const dateStr = new Date().toISOString().split('T')[0];
  a.download = `lexi_backup_${dateStr}.json`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
